import React, { useState } from 'react';
import { TeamMemberInfo } from './utils';

interface TeamNameProps {
  memberInfo: TeamMemberInfo;
  setMemberInfo: (info: TeamMemberInfo) => void;
}

const TeamName: React.FC<TeamNameProps> = ({ memberInfo, setMemberInfo }) => {
  const [teamName, setTeamName] = useState('');

  return (
    <div>
      <h2 className="govuk-heading-m">Team</h2>
      <div className="flex gap-5 items-end">
        <div className="govuk-form-group">
          <label className="govuk-label" htmlFor="team-name-input">
            Which team is this colleague in?
          </label>

          <input
            className="govuk-input govuk-input--width-20"
            id="team-name-input"
            name="teamName"
            type="text"
            autoComplete="teamName"
            placeholder="Enter Name"
            value={memberInfo.teamName}
            onChange={e =>
              setMemberInfo({ ...memberInfo, teamName: e.target.value })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default TeamName;
